export default __webpack_public_path__ + "static/media/jane-churchyard-screengrab-11.5acdb08f.jpg";